import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';

import { AuthService, User } from '../shared/auth/auth.service';

interface NavLink {
  label: string;
  fragment?: string;   // for section anchors — rendered as plain href
  path?: string;       // for standalone routes like /events — rendered as routerLink
}

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, MatIconModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Input() page: 'home' | string = 'home';

  isMenuOpen = false;
  isAuthenticated = false;
  loading = false;

  private userSub?: Subscription;

  navLinks: NavLink[] = [
    { label: 'Home', fragment: 'home' },
    { label: 'About Us', path: '/about' },
    { label: 'Events', path: '/events' },
    { label: 'E-Learning', path: '/e-learning' },
    { label: 'Contact Us', path: '/contact' },
  ];

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userSub = this.authService.currentUser$.subscribe((user: User | null) => {
      this.isAuthenticated = !!user;
    });
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  get isHome(): boolean {
    return this.page === 'home';
  }

  /**
   * Builds a plain href for section anchor links, same approach as the footer.
   * - On home page: '#about' (same-page jump)
   * - On other pages: '/#about' (full navigation back to home, then jump)
   */
  sectionHref(fragment: string): string {
    return this.isHome ? `#${fragment}` : `/#${fragment}`;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  goToDashboard(): void {
    this.closeMenu();
    this.router.navigate(['/app/dashboard']);
  }

  goToLogin(): void {
    if (this.loading) return;
    this.loading = true;
    this.closeMenu();
    this.router.navigate(['/login']).finally(() => (this.loading = false));
  }
}
